import { styled, type StyledComponent } from 'styled-components'

/**
 * A simple button component that uses the secondaryDark color.
 */
export const Button: StyledComponent<
	{
		$variant?: 'link',
	},
	empty,
	HTMLButtonElement
> = styled.button.attrs({
	className: 'font-game-headline bg-game-primary-green text-white',
})`
	border: none;
	padding: var(--spacing) var(--spacing-4x);
	border-radius: 8px;
	font-size: ${({ theme }) => theme.fonts};
	letter-spacing: 1px;
	&:hover {
		filter: brightness(0.9);
	}
	&:active {
		filter: brightness(0.85);
	}
	&:disabled {
		filter: brightness(0.5);
	}
	cursor: pointer;
	transition: filter 0.1s;
	${({ $variant, theme }) =>
		$variant === 'link'
			? `
		background: transparent;
		box-shadow: none;
		border: none;
		text-decoration: underline;
		&:hover:enabled {
			box-shadow: none;
			color: ${theme.neutralLight};
		}
	`
			: ''}
`

/**
 * A button that is designed to hold an icon.
 *
 * Example usage:
 *   <IconButton>
 *     <FaIcon />
 *   </IconButton>
 */
export const IconButton: StyledComponent<
	{},
	empty,
	HTMLButtonElement
> = styled.button`
	background-color: transparent;
	border: none;
	color: ${({ theme }) => theme.iconLight};
	font-size: 2rem;
	padding: 0.5rem;
	margin: 0.5rem;
	transition: all 0.2s ease-in-out;
	border-radius: 50%;
	aspect-ratio: 1;

	svg {
		display: block;
	}

	&:hover {
		transform: scale(1.2);
	}
	&:active {
		transition: transform 0.05s ease-in-out;
		transform: scale(1.1);
	}
`
